var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardDigitalOceanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2157_23042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 15.8543V12.8096C11.2264 12.8096 13.7284 9.61765 12.4909 6.21944C12.0293 4.95739 11.0348 3.96297 9.77279 3.50381C6.37949 2.27614 3.18016 4.76832 3.18016 7.99221H0.142883C0.142883 2.8556 5.11498 -1.15154 10.5045 0.532833C12.8616 1.2719 14.7375 3.14288 15.4668 5.49265C17.1511 10.8895 13.1514 15.8567 8.00003 15.8567V15.8543Z",
    fill: "#0080FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97994 12.8194V9.79199H8.00985V12.8194H4.97994ZM2.6449 15.152V12.8194H4.97994V15.152H2.6449ZM2.6449 12.8194H0.695343V10.8699H2.64735V12.8194H2.6449Z",
    fill: "#0080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2157_23042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7143,
    height: 15.7143,
    fill: "white",
    transform: "translate(0.142853 0.142647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardDigitalOceanIcon);
export default __webpack_public_path__ + "static/media/onboard-digital-ocean-icon.5f53d8ed621a625ef378d090ad80dc67.svg";
export { ForwardRef as ReactComponent };